import React, { useEffect, useState } from "react";
import { useApi } from "utils/hooks/use-api";
import styles from "./policy.module.scss";
import RefreshButton from "components/shared-ui/button/refresh-button";
import PageTitle from "components/shared-ui/pageTitle";
import Button from "components/shared-ui/button";
import { iamService } from "api/services/iam";
import { getDefaultRequestParams, getEmptyPage } from "redux/reducers/entity";
import { ITruncatedPaged } from "api/entities/page";
import { routeUtils } from "utils/route-utils";
import { useNavigate } from "react-router-dom";
import {
  IAMEntityType,
  IIAMEntityRequestParams,
} from "api/entities/iam-entity";
import { DeleteConfirmation } from "../shared-ui/iam/dialogs/delete-confirmation";
import { IAMPolicySortField, IIAMPolicy } from "api/entities/iam-policies";
import { IAMPolicyTable } from "./policy-table/policy-table";
import IAMPolicyPanel from "./policy-panel/policy-panel";

export default function IAMPolicy() {
  const [policyApi, isPolicyLoading] = useApi();
  const [policyPages, setPolicyPage] =
    useState<ITruncatedPaged<IIAMPolicy>>(getEmptyPage());
  const [requestParams, setRequestParams] = useState<
    IIAMEntityRequestParams<IAMPolicySortField>
  >({ ...getDefaultRequestParams() });

  const navigate = useNavigate();

  const fetchData = (query?: IIAMEntityRequestParams<IAMPolicySortField>) => {
    const updatedQuery = { ...requestParams, ...query };
    policyApi(iamService.getPolicies(updatedQuery)).then(setPolicyPage);
    setRequestParams(updatedQuery);
  };

  const handleDeletePolicy = (arn: string) => {
    policyApi(iamService.deletePolicy(arn)).then(() => fetchData({}));
  };

  const handleAddPolicyFormPanelOpen = () => {
    navigate(routeUtils.getRouteToNewIAMPolicy());
  };

  const handleAddPolicyFormPanelClose = () => {
    navigate(routeUtils.getRouteToIAMPolicyList());
  };

  useEffect(() => {
    fetchData(requestParams);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!policyPages.marker) return;
    setRequestParams((prev) => ({ ...prev, marker: policyPages.marker }));
  }, [policyPages]);

  return (
    <>
      <div className={styles.header}>
        <PageTitle title={`Policies`}>
          <RefreshButton onClick={() => fetchData()} />
        </PageTitle>

        <div className={styles["action-buttons"]}>
          <Button
            testId="group-create-button"
            colors="primary"
            onClick={handleAddPolicyFormPanelOpen}
          >
            Create
          </Button>
        </div>
      </div>

      <IAMPolicyTable
        isLoading={isPolicyLoading}
        page={policyPages}
        isRowClickable
        hasManageColumn
        requestParams={requestParams}
        setRequestParams={fetchData}
      />
      <IAMPolicyPanel
        embedded={false}
        onClose={handleAddPolicyFormPanelClose}
        fetchPage={fetchData}
      />

      <DeleteConfirmation
        onDelete={handleDeletePolicy}
        type={IAMEntityType.Group}
      />
    </>
  );
}
